import { css } from "@emotion/react"
import { colorsCP } from "@mkt/cp/src/styles/Tokens"
import { container, getDuration } from "@mkt/cp/src/styles/Functions"
import { below, above } from "@mkt/cp/src/styles/Breakpoints"
import { animeShow } from "@mkt/ui/styles/Keyframes"

const boxesHolderWrapperAnimation = (valueList) => {
  const cssAnimation = {}
  valueList.forEach((item) => {
    cssAnimation[`&:nth-of-type(${item})`] = {
      animation: `${animeShow} ${getDuration(item)} 0.2s linear forwards;`,
    }
  })

  return cssAnimation
}

export const twoCards = css`
  background-color: ${colorsCP["blue-40"]};
`
export const twoCardsContainer = css`
  ${container};
  padding-top: 32px;
  padding-bottom: 32px;

  ${above["m"]} {
    padding-top: 72px;
    padding-bottom: 72px;
  }

  ${above["xl"]} {
    width: 1052px;
  }
`
export const twoCardsTitle = css`
  opacity: 0;
  animation: ${animeShow} ${getDuration(1)} 0.4s linear forwards;
  margin-bottom: 16px;
  color: ${colorsCP["neutral-00"]};

  ${above["m"]} {
    text-align: center;
  }

  ${below["m"]} {
    font-size: 20px;
    line-height: 28px;
  }
`
export const twoCardsSubtitle = css`
  opacity: 0;
  max-width: 815px;
  font-size: 16px;
  line-height: 24px;
  margin-inline: auto;
  animation: ${animeShow} ${getDuration(1)} 0.5s linear forwards;
  margin-bottom: 32px;
  color: ${colorsCP["neutral-00"]};

  ${above["m"]} {
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    margin-bottom: 40px;
  }
`
export const twoCardsContent = css`
  gap: 32px;
  display: flex;

  ${below["m"]} {
    flex-direction: column;
  }
`
export const twoCardsItem = css`
  padding: 16px;
  border-radius: 16px;
  background-color: ${colorsCP["neutral-00"]};

  ${above["m"]} {
    width: 50%;
    padding: 32px;
  }

  ${boxesHolderWrapperAnimation([1, 2])}
`
export const twoCardsItemTitle = css`
  margin-bottom: 16px;
  color: ${colorsCP["neutral-70"]};
`
export const twoCardsItemText = css`
  color: ${colorsCP["neutral-50"]};

  > p {
    margin-bottom: 24px;
  }

  ol {
    padding-left: 20px;
    color: ${colorsCP["neutral-50"]};

    > li {
      list-style: decimal;
      margin-bottom: 4px;

      &::marker {
        font-weight: 700;
      }
    }
  }
`
export const twoCardsList = css`
  display: flex;
  margin-top: 24px;
  flex-direction: column;
  color: ${colorsCP["neutral-50"]};
`
export const twoCardsListItem = css`
  padding-bottom: 24px;

  &:last-child {
    padding-bottom: 0;
  }

  + div {
    padding-top: 24px;
    border-top: 1px solid ${colorsCP["neutral-20"]};
  }
`
export const twoCardsListItemTitle = css`
  gap: 16px;
  display: flex;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 8px;
`
export const twoCardsTextBottom = css`
  ${twoCardsSubtitle};
  max-width: 760px;
  margin-top: 40px;
  margin-bottom: 0;

  ${above["m"]} {
    margin-top: 40px;
    margin-bottom: 0;
  }

  p + p {
    margin-top: 32px;
  }
`
export const button = (showLess) => {
  const hideButton = css`
    display: none;
  `

  return css`
    margin-top: 24px;
    margin-inline: auto;

    ${above["m"]} {
      max-width: 240px;
      margin-top: 32px;
    }

    button.iq-btn--color-white {
      color: ${colorsCP["neutral-00"]};
      border-color: ${colorsCP["neutral-00"]};

      &:hover {
        color: ${colorsCP["blue-60"]};
        border-color: ${colorsCP["blue-60"]};
      }
    }

    ${showLess && hideButton}
  `
}
